var grey = {
  // Background
  50: "#f8f8f8",
  // Background
  100: "#f1f1f1",
  // Border, Disabled
  200: "#e3e3e3",
  // Closed, Inactive
  300: "#ababab",
  // Icon, Text – Body Secondary
  400: "#737373",
  // Icon, Text – Body
  500: "#505050",
  // Text – Heading, Body Dark
  600: "#232323"
};
export var colors = {
  blue: "#0a5fd2",
  darkOrange: "#fa4616",
  green: "#008906",
  grey: grey,
  lightGreen: "#a5bb48",
  lightOrange: "#ffb432",
  purple: "#c34789",
  red: "#ec0000",
  white: "#ffffff"
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tdWktdGhlbWVzL2NvcmUvY29sb3JzLnRzIl0sIm5hbWVzIjpbImdyZXkiLCJjb2xvcnMiLCJibHVlIiwiZGFya09yYW5nZSIsImdyZWVuIiwibGlnaHRHcmVlbiIsImxpZ2h0T3JhbmdlIiwicHVycGxlIiwicmVkIiwid2hpdGUiXSwibWFwcGluZ3MiOiJBQUFBLElBQU1BLElBQUksR0FBRztBQUNYO0FBQ0EsTUFBSSxTQUZPO0FBR1g7QUFDQSxPQUFLLFNBSk07QUFLWDtBQUNBLE9BQUssU0FOTTtBQU9YO0FBQ0EsT0FBSyxTQVJNO0FBU1g7QUFDQSxPQUFLLFNBVk07QUFXWDtBQUNBLE9BQUssU0FaTTtBQWFYO0FBQ0EsT0FBSztBQWRNLENBQWI7QUFpQkEsT0FBTyxJQUFNQyxNQUFNLEdBQUc7QUFDcEJDLEVBQUFBLElBQUksRUFBRSxTQURjO0FBRXBCQyxFQUFBQSxVQUFVLEVBQUUsU0FGUTtBQUdwQkMsRUFBQUEsS0FBSyxFQUFFLFNBSGE7QUFJcEJKLEVBQUFBLElBQUksRUFBSkEsSUFKb0I7QUFLcEJLLEVBQUFBLFVBQVUsRUFBRSxTQUxRO0FBTXBCQyxFQUFBQSxXQUFXLEVBQUUsU0FOTztBQU9wQkMsRUFBQUEsTUFBTSxFQUFFLFNBUFk7QUFRcEJDLEVBQUFBLEdBQUcsRUFBRSxTQVJlO0FBU3BCQyxFQUFBQSxLQUFLLEVBQUU7QUFUYSxDQUFmIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgZ3JleSA9IHtcbiAgLy8gQmFja2dyb3VuZFxuICA1MDogXCIjZjhmOGY4XCIsXG4gIC8vIEJhY2tncm91bmRcbiAgMTAwOiBcIiNmMWYxZjFcIixcbiAgLy8gQm9yZGVyLCBEaXNhYmxlZFxuICAyMDA6IFwiI2UzZTNlM1wiLFxuICAvLyBDbG9zZWQsIEluYWN0aXZlXG4gIDMwMDogXCIjYWJhYmFiXCIsXG4gIC8vIEljb24sIFRleHQg4oCTIEJvZHkgU2Vjb25kYXJ5XG4gIDQwMDogXCIjNzM3MzczXCIsXG4gIC8vIEljb24sIFRleHQg4oCTIEJvZHlcbiAgNTAwOiBcIiM1MDUwNTBcIixcbiAgLy8gVGV4dCDigJMgSGVhZGluZywgQm9keSBEYXJrXG4gIDYwMDogXCIjMjMyMzIzXCIsXG59O1xuXG5leHBvcnQgY29uc3QgY29sb3JzID0ge1xuICBibHVlOiBcIiMwYTVmZDJcIixcbiAgZGFya09yYW5nZTogXCIjZmE0NjE2XCIsXG4gIGdyZWVuOiBcIiMwMDg5MDZcIixcbiAgZ3JleSxcbiAgbGlnaHRHcmVlbjogXCIjYTViYjQ4XCIsXG4gIGxpZ2h0T3JhbmdlOiBcIiNmZmI0MzJcIixcbiAgcHVycGxlOiBcIiNjMzQ3ODlcIixcbiAgcmVkOiBcIiNlYzAwMDBcIixcbiAgd2hpdGU6IFwiI2ZmZmZmZlwiLFxufTtcbiJdfQ==